export const classes = Object.freeze({
  /*  -------- Product Container --------  */
  class: {
    container: 'productList',
    count: 'h1[role=heading]'
  },

  /*  -------- Product Instances --------  */
  // Unused: imageLink, price, reviewCount
  instance: {
    container: 'p',
    // image: 'preview-thumb lazy',
    link: 'preview-details',
    salePrice: 'sale-price',
    priceContainer: 'price',
    rating: 'pR',
    // swatch: 'lazy', // Class is variable, depending upon active color ID.
    swatchContainer: 'swatchImages',
    title: 'prd-name'
  }
})
